import { load, save, remove } from 'data/browserStorage';
import { COOKIE_STORAGE, SESSION_STORAGE, TOKEN_KEY } from 'data/browserStorage/constants';

export function loadSession() {
  return load(TOKEN_KEY, COOKIE_STORAGE) || load(TOKEN_KEY, SESSION_STORAGE);
}

export function saveSession(bearerToken, remember, expiry) {
  if (remember) {
    save(TOKEN_KEY, bearerToken, COOKIE_STORAGE, { expiry });
  } else {
    save(TOKEN_KEY, bearerToken, SESSION_STORAGE);
  }
}

export function removeSession() {
  remove(TOKEN_KEY, COOKIE_STORAGE);
  remove(TOKEN_KEY, SESSION_STORAGE);
}
